// extracted by mini-css-extract-plugin
module.exports = {"CGUItem":"cgu-panel_CGUItem__272lu","IFrame":"cgu-panel_IFrame__kO1tz","Modal":"cgu-panel_Modal__1FFyY","Title":"cgu-panel_Title__3PxJC"};